import { Brick, Predicate, Query, registerBrick, WorkflowObjectState } from 'olympe';
import { executeLambda } from '../../node/BackendData/LambdaExecutor';
import { getLogger } from '@olympeio/core';
import BCP from './DM_BCP.js';
import { BCP_WORKFLOW_STATES } from './BcpWorkflowAuthorizations';
import { sleep } from "../utils/CommonUtil.js"
import { generateWeeklyPsEmailContents, parseNameEmail } from './psWeeklyEmailTemplate.js';

export default class PSWeeklyNotification extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} sendEmail
     * @param {function()} forwardEvent
     */
    async update($, [sendEmail], [forwardEvent]) {
        const logger = getLogger('PSWeeklyNotification');

        logger.info(`PSWeeklyNotification - Started at ${new Date(Date.now()).toISOString()}`);

        // Calculate the date 7 days before today and reset its time.
        const today = new Date();
        today.setDate(today.getDate() - 7);
        today.setHours(0, 0, 0, 0);

        logger.info(`Filtering BCP requests pending since: ${today}`);

        const validStates = [
            BCP_WORKFLOW_STATES.ALT_VS_SUGG_BY_BP,
            BCP_WORKFLOW_STATES.ALT_VS_CHECK_BY_PM,
            BCP_WORKFLOW_STATES.CTAG_ACCEPTANCE,
            BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_1,
            BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_2,
        ];
        // Create a Predicate.or condition for the target states
        const statePredicate = Predicate.or(...validStates.map((state) => Predicate.equals(WorkflowObjectState.stateProp, state)));

        // Create a Predicate for the date filter (less than 7 days)
        const datePredicate = Predicate.smallerThan(WorkflowObjectState.dateTimeProp, today);

        // Combine the predicates using Predicate.and
        const combinedPredicate = Predicate.and(datePredicate, statePredicate);

        let query = Query.instancesOf(BCP).andReturn().follow(WorkflowObjectState.currentObjectRel.getInverse()).filter(combinedPredicate).andReturn();

        try {
            const queryResult = await query.execute();
            logger.info('query result', queryResult.toArray());
            const identifiedUserforBcp = [];
            // Process each BCP object and map it to relevant users based on its state.
            queryResult.toArray().forEach((element) => {
                const workflow = element[1].get(WorkflowObjectState.stateProp);
                const bcpObject = element[0];
                let emailToUser = [];
                // get the PS value
                const procurementSpecialist = bcpObject.get(BCP.procurementSpecialistProp)
                // get user details by workflow state and the PS value in email to send 
                if ((workflow === BCP_WORKFLOW_STATES.ALT_VS_SUGG_BY_BP || BCP_WORKFLOW_STATES.ALT_VS_CHECK_BY_PM || BCP_WORKFLOW_STATES.CTAG_ACCEPTANCE
                    || BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_1 || BCP_WORKFLOW_STATES.QA_FACTORY_ACCEPTANCE_2) && procurementSpecialist) {
                    emailToUser.push(bcpObject.get(BCP.procurementSpecialistProp))
                }
                // Avoid duplicate emails
                emailToUser = [...new Set(emailToUser.map(email => email.toLowerCase()))];
                identifiedUserforBcp.push({
                    bcpObjet: bcpObject,
                    emailto: emailToUser,
                });
            });

            // Group BCP objects by email addresses.
            const groupByEmail = (data) => {
                const emailMap = new Map();
                data.forEach(({ bcpObjet, emailto }) => {
                    emailto.forEach((email) => {
                        if (!emailMap.has(email)) {
                            emailMap.set(email, []);
                        }
                        emailMap.get(email).push(bcpObjet);
                    });
                });
                return Array.from(emailMap, ([mailto, bcpobjects]) => ({
                    mailto,
                    bcpobjects,
                }));
            };

            const groupedByEmail = groupByEmail(identifiedUserforBcp);
            logger.info('groupped by email', groupedByEmail);

            // Send emails asynchronously
            const emailPromises = groupedByEmail.map(async (emailData, index) => {
                logger.info("PSWeeklyNotification - Before sending emails", index)
                try {
                    //logger.info(":: remainder: PS weekly email ::", (index + 1) % 100)
                    if ((index + 1) % 100 === 0) {
                        await sleep(2000);
                    }
                    const emailContent = await generateWeeklyPsEmailContents(emailData, $);
                    await executeLambda($, sendEmail, [parseNameEmail(emailData.mailto).email, 'BCP request - PS Weekly notification', emailContent]);
                    logger.info(`PSWeeklyNotification - Email sent to ${parseNameEmail(emailData.mailto).email}`);
                } catch (error) {
                    logger.error(`PSWeeklyNotification - Failed to send email to ${parseNameEmail(emailData.mailto).email}:`, error);
                }
            });

            await Promise.all(emailPromises);
            logger.info('PSWeeklyNotification - All weekly PS emails processed successfully.');
        } catch (error) {
            logger.error('PSWeeklyNotification - Error executing query:', error);
        }
        finally {
            logger.info(`PSWeeklyNotification - Completed at ${new Date(Date.now()).toISOString()}`);

            forwardEvent();
        }
    }
}

registerBrick('01988481a508c17e8767', PSWeeklyNotification);
